import React from 'react';
import PropTypes from 'prop-types';

import { Aircraft } from 'models';

import { Row, Col } from 'react-bootstrap';
import SkyPulseTable from 'components/SkyPulseTable';
import LOPA from 'components/LOPA';

import styles from '../styles.module.css';

const columns = [
  {
    name: 'LRU',
    key: 'lru',
    size: 'small',
    dataCyClassName: 'Ship-CrewPanelsTableColumn-Lru',
  },
  {
    name: 'Pos',
    key: 'pos',
    size: 'xsmall',
    dataCyClassName: 'Ship-CrewPanelsTableColumn-Pos',
  },
];

const CrewPanels = (props) => {
  const { aircraft, onRowClick, selectedLru, navigate } = props;
  const { lopa: aircraftLopa } = aircraft;
  const { crew_panels: crewPanels } = aircraftLopa;

  const lopaData = {};
  const cmpTableDataMap = {};
  crewPanels.forEach((cmp) => {
    const { id, lru_type: lruType } = cmp;
    const cmpTypeName = lruType.value;

    if (!cmpTableDataMap[cmpTypeName]) {
      cmpTableDataMap[cmpTypeName] = [];
    }

    cmpTableDataMap[cmpTypeName].push({
      lru: lruType.value,
      pos: id,
      id: id,
    });

    const deviceType = aircraftLopa.getDeviceTypeByLRUTypePosition(
      lruType.id,
      id,
    );
    // Lopa Data
    if (!lopaData[deviceType]) {
      lopaData[deviceType] = {};
    }
    lopaData[deviceType][id] = {
      active: true,
      selected: selectedLru === id,
    };
  });

  const tableMaxHeight = `calc(100%/${Object.keys(cmpTableDataMap)?.length})`;
  return (
    <Row className={styles.root} noGutters>
      <Col className="h-100">
        <LOPA
          mode="config"
          data={lopaData}
          aircraft={aircraft}
          navigate={navigate}
        />
        <Row className={styles.tableContainer} noGutters>
          <Col className="h-100 d-flex flex-column justify-content-evenly">
            {Object.keys(cmpTableDataMap).map((key, index) => {
              const tData = cmpTableDataMap[key];
              return (
                <Row
                  key={index}
                  className={styles.multiTable}
                  style={{ maxHeight: tableMaxHeight }}
                  noGutters
                >
                  <Col className="h-100">
                    <SkyPulseTable
                      title={`CMP (${key})`}
                      columns={columns}
                      rows={tData}
                      onRowClick={onRowClick}
                      selectedId={selectedLru}
                    />
                  </Col>
                </Row>
              );
            })}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

CrewPanels.propTypes = {
  aircraft: PropTypes.instanceOf(Aircraft).isRequired,
  onRowClick: PropTypes.func.isRequired,
};

export default CrewPanels;
